import { render, staticRenderFns } from "./EditPageItem.vue?vue&type=template&id=23364219&"
import script from "./EditPageItem.vue?vue&type=script&lang=js&"
export * from "./EditPageItem.vue?vue&type=script&lang=js&"
import style0 from "./EditPageItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VFlex,VForm,VLayout})
